import { domToReact } from 'html-react-parser';

import { parserOptions } from '@commons/components/RichText';
import type { Template } from '@commons/components/RichText/templates';
import Grid, { type GridSize } from '@commons/containers/Grid';
import type { ResponsiveStyle } from '@commons/types/styles';

import styles from './TwoByTwoGrid.module.scss';

// The amound of rows / columns per breakpoint.

const size: ResponsiveStyle<GridSize> = {
  xs: 1,
  md: 2,
};

/**
 * 2x2 grid CKEditor template.
 *
 * @param nodes - An array of DOM nodes to render.
 *
 * @returns A rendered React component.
 */

export const TwoByTwoGridTemplate: Template = ({ nodes }) => (
  <Grid gap="sm" width={12} columns={size}>
    {domToReact(nodes, parserOptions)}
  </Grid>
);

/**
 * 2x2 grid with border CKEditor template.
 *
 * @param nodes - An array of DOM nodes to render.
 *
 * @returns A rendered React component.
 */

export const TwoByTwoGridTemplateWithBorder: Template = ({ nodes }) => (
  <Grid gap="sm" width={12} columns={size} className={styles.withBorder}>
    {domToReact(nodes, parserOptions)}
  </Grid>
);
